export default __webpack_public_path__ + "static/media/AppPcH.e84f1b1c.png";